import QueryStringAddon from "wretch/addons/queryString";
import FormDataAddon from "wretch/addons/formData";
import wretch from "wretch";

export const http = wretch("/api", { credentials: "include" })
  .headers({
    "x-requested-with": "XMLHttpRequest", // used to disable default browser popup
  })
  .addon(QueryStringAddon)
  .addon(FormDataAddon);
